import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, apiKey, 'account-code'] as const
const locationCredentialTypes = ['sub-key'] as const

export type mihdCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]
export const mihdDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const mihd: CarrierDef<mihdCredType> = {
  name: 'Mainfreight',
  scac: 'mihd',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['sub-key', 'ref1']],
  engineLayers: ['rating', 'pickup', 'documents', 'tracking'],
  documentTypes: mihdDocumentTypes,
}
